import { render, staticRenderFns } from "./google-reviews.vue?vue&type=template&id=5eaf2d0d&scoped=true&"
import script from "./google-reviews.vue?vue&type=script&lang=js&"
export * from "./google-reviews.vue?vue&type=script&lang=js&"
import style0 from "./google-reviews.vue?vue&type=style&index=0&id=5eaf2d0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaf2d0d",
  null
  
)

export default component.exports